import { Component } from '@angular/core';
import { NotificationService } from '../../../../../service';

@Component({
  standalone: false,
  selector: 'siths-eid-admin-privileges-ws-clients',
  templateUrl: './privileges-ws-clients.component.html',
  styleUrls: ['./privileges-ws-clients.component.scss']
})
export class PrivilegesWsClientsComponent {
  constructor(private notificationService: NotificationService) {}

  public notify(msg: string): void {
    this.notificationService.success(msg);
  }
}
